'use strict';

export default function($stateProvider) {
  'ngInject';
  $stateProvider
    // .state('order', {
    //   url: '/order',
    //   template: '<order></order>',
    //   authenticate: true
    // })
    // .state('orderEdit', {
    //   url: '/order/:id',
    //   template: '<order></order>',
    //   authenticate: true
    // });
    .state('order', {
      url: '/order',
      template: '<ordernew></ordernew>',
      authenticate: true
    })
    .state('orderEdit', {
      url: '/order/:id',
      template: '<ordernew></ordernew>',
      authenticate: true
    });
}



// WEBPACK FOOTER //
// ./client/app/order/order.routes.js